export default "__VITE_ASSET__CTEfBAqs__"